import { render, staticRenderFns } from "./RoleInfoContent.vue?vue&type=template&id=1bf50148&scoped=true"
import script from "./RoleInfoContent.vue?vue&type=script&lang=js"
export * from "./RoleInfoContent.vue?vue&type=script&lang=js"
import style0 from "./RoleInfoContent.vue?vue&type=style&index=0&id=1bf50148&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf50148",
  null
  
)

export default component.exports